import { render, staticRenderFns } from "./IconHomeFilled.vue?vue&type=template&id=2867bb46&scoped=true"
import script from "./IconHomeFilled.vue?vue&type=script&lang=js"
export * from "./IconHomeFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867bb46",
  null
  
)

export default component.exports